import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LOG_CONTEXT } from '@rms/core/http';
import { environment } from '@rms/env';
import { PageableParam, Paginated } from '@rms/sdk/models';
import { createFilterParams, Filter } from '@rms/ui/filters';
import { Observable } from 'rxjs';

import { Partner, PartnerCreateRequest, PartnerPatchRequest } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PartnerApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiEndpoint}/v1/im/partners`;

  public getPartners({ page, size, sort }: PageableParam, filters: Filter[] = []): Observable<Paginated<Partner>> {
    const params = createFilterParams(
      filters,
      new HttpParams({ fromObject: sort?.length ? { page, size, sort } : { page, size } })
    );

    return this.http.get<Paginated<Partner>>(this.baseUrl, {
      params,
      context: new HttpContext().set(LOG_CONTEXT, 'PartnerApiService.getPartners'),
    });
  }

  public getPartner(partnerId: string): Observable<Partner> {
    return this.http.get<Partner>(`${this.baseUrl}/${partnerId}`, {
      context: new HttpContext().set(LOG_CONTEXT, 'PartnerApiService.getPartner'),
    });
  }

  public createPartner(request: PartnerCreateRequest): Observable<Partner> {
    return this.http.post<Partner>(this.baseUrl, request, {
      context: new HttpContext().set(LOG_CONTEXT, 'PartnerApiService.createPartner'),
    });
  }

  public updatePartner(partnerId: string, request: PartnerPatchRequest): Observable<Partner> {
    return this.http.patch<Partner>(`${this.baseUrl}/${partnerId}`, request, {
      context: new HttpContext().set(LOG_CONTEXT, 'PartnerApiService.updatePartner'),
    });
  }

  public deletePartner(partnerId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${partnerId}`, {
      context: new HttpContext().set(LOG_CONTEXT, 'PartnerApiService.deletePartner'),
    });
  }
}
